import React from "react"
import ReactTable from "react-table-v6";
import UserStore from "../../../stores/UserStore";
import EventUtil from "../../../utils/EventUtil";
import { Link } from "react-router";
import moment from "moment-timezone";

export class TagEventTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      pages: 0,
      loading: false
    }

    this._onFetchData = this._onFetchData.bind(this);
  }

  async _onFetchData(state, _) {
    const { eventBucketId, tagId } = this.props

    this.setState({ loading: true })

    const apiKey = UserStore.getState().apiKey

    const data = await EventUtil.fetchAllByTag(apiKey, eventBucketId, tagId, {
      page: state.page,
      sorted: state.sorted,
    })

    this.setState({ data: data.events, pages: data.pages, loading: false });
  }

  render() {
    const { timezone } = this.props;

    const columns = [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        id: "start_time",
        Header: "Start Time",
        accessor: (row) => moment(row.start_time).tz(timezone || "America/Kentucky/Monticello").format("MMMM D, YYYY h:mm A"),
      },
      {
        id: "end_time",
        Header: "End Time",
        accessor: (row) => moment(row.end_time).tz(timezone || "America/Kentucky/Monticello").format("MMMM D, YYYY h:mm A"),
      },
      {
        id: "type",
        Header: "Type",
        accessor: (row) => row.is_virtual ? "Virtual" : "Physical",
      },
      {
        Header: "Actions",
        sortable: false,
        Cell: props => (
          <div>
            <Link
              to={`/event_buckets/${this.props.eventBucketId}/events/${props.original.id}`}
              onlyActiveOnIndex={false}
            >View</Link>
            &nbsp;
            <Link
              to={`/event_buckets/${this.props.eventBucketId}/events/${props.original.id}/edit`}
              onlyActiveOnIndex={false}
            >Edit</Link>
          </div>
        )
      }
    ]

    return (
      <div style={{ marginTop: 16 }}>
        <h2>Events with Tag</h2>
        <ReactTable
          columns={columns}
          data={this.state.data}
          loading={this.state.loading}
          manual
          showPageSizeOptions={false}
          onFetchData={this._onFetchData}
          pageSize={10}
          pages={this.state.pages}
          defaultSorted={[{ id: "name", desc: false }]}
        />
      </div>

    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/tag-view/tag-event-table.jsx